/**
 * Alpha Rings P0.3 — sticky ATC.
 * Watches the real add button. Toggles a class on a separate bar.
 * Does not write overflow, position, height, or touch-action on document/body/main.
 */
(function () {
  if (window.AlphaStickyAtcInit) return;
  window.AlphaStickyAtcInit = true;

  if (/[?&]alpha_sticky=0(?:&|$)/.test(window.location.search)) return;
  if (!('IntersectionObserver' in window)) return;

  var bar = document.querySelector('[data-alpha-sticky-atc]');
  var mainBtn = document.querySelector('[data-alpha-main-atc]');
  if (!bar || !mainBtn) return;

  var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var mainVisible = true;

  function drawerOpen() {
    return Boolean(
      document.querySelector('cart-drawer.active') ||
        document.body.classList.contains('overflow-hidden') ||
        document.body.classList.contains('js-drawer-open')
    );
  }

  function mobile() {
    return !mq || mq.matches;
  }

  function sync() {
    var show = !mainVisible && mobile() && !drawerOpen();
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) {
      bar.removeAttribute('inert');
    } else {
      bar.setAttribute('inert', '');
    }
  }

  sync();

  var io = new IntersectionObserver(
    function (entries) {
      var entry = entries[0];
      if (!entry) return;
      mainVisible = entry.isIntersecting;
      sync();
    },
    { root: null, rootMargin: '0px', threshold: 0 }
  );

  io.observe(mainBtn);

  var stickyBtn = bar.querySelector('[data-alpha-sticky-atc-btn]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      if (mainBtn.disabled) return;
      mainBtn.click();
      // Cart drawer opens after async add — re-sync a few times.
      [50, 150, 300, 600, 1200].forEach(function (ms) {
        window.setTimeout(sync, ms);
      });
    });
  }

  document.addEventListener(
    'click',
    function () {
      window.requestAnimationFrame(sync);
      window.setTimeout(sync, 200);
      window.setTimeout(sync, 500);
    },
    true
  );

  var drawer = document.querySelector('cart-drawer');
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(function () {
      sync();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  if (mq) {
    var onMq = function () {
      sync();
    };
    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);
  }
})();
